import React, { Component } from 'react';
import Select from '../Select';
import { getSysFieldid } from '@platform/api';
require('./index.less');
const Option = Select.Option;
class SelectBetween extends Component {
	constructor(props) {
		super(props);
		this.state = {
			value: props.value
		};
	}
	componentWillReceiveProps(nextProps) {
		// this.state.value = nextProps.value;
		this.setState({ value: nextProps.value });
	}
	render() {
		let { fieldid, popData, mustFill, options, ...others } = this.props;
		if (getSysFieldid(fieldid)) {
			popData ? popData.fieldid = `${fieldid}_select` : popData = { "fieldid": `${fieldid}_select` }
		}
		return (
			<div className="selectbetween" fieldid={fieldid ? fieldid : null}>
				<div className="startSelect selectbetween-item">
					<Select
						{...others}
						popData={popData}
						value={this.state.value[0]}
						onChange={this.props.onChange && this.props.onChange.bind(this, 0)}
					>
						{this.props.options &&
							this.props.options.map((val, index) => {
								return (
									<Option key={index} value={String(val.value)}>
										{val.display}
									</Option>
								);
							})}
					</Select>
				</div>
				<div className="line">-</div>
				{mustFill}
				<div className="endSelect selectbetween-item">
					<Select
						{...others}
						popData={popData}
						value={this.state.value[1]}
						onChange={this.props.onChange && this.props.onChange.bind(this, 1)}
					>
						{this.props.options &&
							this.props.options.map((val, index) => {
								return (
									<Option key={index} value={String(val.value)}>
										{val.display}
									</Option>
								);
							})}
					</Select>
				</div>
			</div>
		);
	}
}

export default SelectBetween;
